<ng-container *ngIf="isUserDataSet"
              cdk-virtual-scroll-viewport>
  <app-header-switch class="d-block"
                     [headerType]="headerType"></app-header-switch>


  <router-outlet></router-outlet>


  <app-footer *ngIf="!hideFooter"
              [ngClass]="{'footer--gray': headerType === 'admin' }"></app-footer>
</ng-container>
